import {safeDefineElement} from "@/scripts/core/global";
import {ShareButtons} from "@/scripts/optional/share-buttons";

safeDefineElement(ShareButtons)
